module.exports = __webpack_public_path__ + "img/share_fb.ef76949f.png";